import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../../services/analyticsService';

/**
 * Boots GTM / GA4 / Meta / Ads once, then records a page_view on every route change.
 */
function AnalyticsBootstrap() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}

export default AnalyticsBootstrap;
